<template>
  <div>
    <b-container>
      <b-row class="justify-content-center">
        <b-col md="10">
          <h1>Intuit QuickBooks Connect</h1>
          <h2>WordPress Multisite</h2>
          <p>QuickBooks Connect is an event that brings entrepreneurs, small business owners, accountants &amp; developers together to grow, learn &amp; connect with each other. My team and I developed a custom WordPress theme for this multi-regional website that provides potential and confirmed attendees with all the information they need about the event.</p>

          <p>Leveraging the Aventri event platform API, Agenda, Speakers, & Sponsors are dynamically populated on the website preventing administrators from needing to maintain data in multiple systems.</p>
          
          <b-button variant="primary" href="http://quickbooksconnect.com" target="_blank">
            Visit Website <font-awesome-icon icon="external-link-alt" class="ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-3 mt-lg-0">
        <b-col lg="6">
          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/qbc-home.png')"
            :srcset="require('../../assets/screens/qbc-home@2x.png') + ' 2x'" />

          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/qbc-about.png')"
            :srcset="require('../../assets/screens/qbc-about@2x.png') + ' 2x'" />
        </b-col>

        <b-col lg="6">
          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/qbc-pricing.png')"
            :srcset="require('../../assets/screens/qbc-pricing@2x.png') + ' 2x'" />

          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/qbc-exhibitors.png')"
            :srcset="require('../../assets/screens/qbc-exhibitors@2x.png') + ' 2x'" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      titleTemplate: 'Intuit QuickBooks Connect | %s',
    }
  }
</script>
